import { FC } from 'react';
import {
  useTranslation,
  AlertMessage,
  Button,
  ButtonSize,
  ButtonStyles,
  Theme,
  ButtonTypes,
  AlertMessageWidth,
  IconAlignment,
} from '@nextgen-web-framework/all';
import { MyShopStatusEnum } from '@commerce-myshop-webcomponents/sdk';
import { SharingBannerProps } from './types/propTypes';
import styles from './SharingBanner.module.scss';

const SharingBanner: FC<SharingBannerProps> = (props: SharingBannerProps): JSX.Element | null => {
  const t = useTranslation();
  const { status, onUpdateStatus, isReceiver, isFirstTimer } = props;

  if (!isReceiver) {
    if (isFirstTimer) {
      return (
        <div
          className={`${styles['myshop-sharing-banner-container']} ${styles['action']}`}
          data-testid={'myshop-sharing-banner-test-id'}
        >
          <div className={styles['myshop-sharing-banner-content-container']}>
            <div className={styles['myshop-sharing-banner-content-title']}>{t('myshop.SharingBanner.title')}</div>
            <div className={styles['myshop-sharing-banner-content-subtitle']}>{t('myshop.SharingBanner.subtitle')}</div>
          </div>
          <div className={styles['myshop-sharing-banner-button-container']}>
            <Button
              title={t('myshop.SharingBanner.buttonTitle')}
              buttonStyle={ButtonStyles.SOLID}
              theme={Theme.PURPLE}
              size={ButtonSize.SMALL}
              data-testid={'myshop-sharing-banner-btn'}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                onUpdateStatus();
              }}
            />
          </div>
        </div>
      );
    }

    return (
      <div className={styles['myshop-sharing-alert-container']} data-testid={'myshop-sharing-alert-test-id'}>
        <AlertMessage
          className={`${styles['myshop-sharing-alert-message-content']}`}
          theme={Theme.ACTION}
          icon={status === MyShopStatusEnum.Active ? 'eye' : 'eye-slash'}
          content={{
            heading: getAlertMessageProps(status, t).heading,
            detail: getAlertMessageProps(status, t).detail,
          }}
          width={AlertMessageWidth.FULL_WIDTH}
          iconAlignment={IconAlignment.CENTER}
          textLink={{
            text: getAlertMessageProps(status, t).text,
            onClick: (e) => {
              e.stopPropagation();
              e.preventDefault();
              onUpdateStatus();
            },
          }}
        />
      </div>
    );
  } else {
    return null;
  }
};

export default SharingBanner;

const getAlertMessageProps = (
  status: string,
  t: Function,
): {
  heading: string;
  detail: string;
  text: string;
} => {
  if (status === MyShopStatusEnum.Active) {
    return {
      heading: t('myshop.SharingBanner.publicModeActive.title'),
      detail: t('myshop.SharingBanner.publicModeActive.subtitle'),
      text: t('myshop.SharingBanner.privateMode'),
    };
  } else {
    return {
      heading: t('myshop.SharingBanner.privateModeActive.title'),
      detail: t('myshop.SharingBanner.privateModeActive.subtitle'),
      text: t('myshop.SharingBanner.publicMode'),
    };
  }
};
